import { render, staticRenderFns } from "./HomeNewsCount.vue?vue&type=template&id=fc827f9e&scoped=true"
import script from "./HomeNewsCount.vue?vue&type=script&lang=js"
export * from "./HomeNewsCount.vue?vue&type=script&lang=js"
import style0 from "./HomeNewsCount.vue?vue&type=style&index=0&id=fc827f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc827f9e",
  null
  
)

export default component.exports